<lvr-heading>
	{{ 'institution.persons.title' | transloco: { name: institution().name } }}
</lvr-heading>

<lvr-button
	variant="primary"
	[label]="'institution.persons.create_tt' | transloco"
	[type]="'button'"
	(clicked)="openNewInstitutionPersonDialog()"
	icon="add"
>
</lvr-button>

<lvr-institution-persons-list
	[personsPage]="personsPage()"
	(pageRequested)="onPageRequested($event)"
	[institutionName]="institution().name"
>
</lvr-institution-persons-list>
